import { ArrowUpRight, Instagram, Mail } from "lucide-react";
import Reveal, { SectionHead } from "@/components/Reveal";

export default function Contact() {
    return (
        <section id="contact" className="scroll-mt-24 border-t border-white/5 py-20 sm:py-24 lg:py-28">
            <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-12">
                <SectionHead
                    eyebrow="Contact"
                    title="Say hello."
                    sub="Questions, feedback or early access — we read everything."
                    testid="contact-heading"
                />

                <div className="mt-12 grid grid-cols-1 gap-4 sm:gap-5 md:grid-cols-2">
                    <Reveal delay={0.05}>
                        <a
                            data-testid="contact-email-link"
                            href="mailto:workfynary@gmail.com"
                            className="group flex h-full flex-col justify-between rounded-[24px] border border-white/10 bg-fynary-surface p-6 transition-[border-color,background-color] duration-200 hover:border-fynary-lime/40 hover:bg-fynary-surface2 sm:p-8"
                        >
                            <div className="flex items-start justify-between">
                                <span className="flex h-12 w-12 items-center justify-center rounded-full bg-fynary-lime/10">
                                    <Mail className="h-5 w-5 text-fynary-lime" />
                                </span>
                                <ArrowUpRight className="h-5 w-5 text-fynary-muted transition-[color,transform] duration-200 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-fynary-lime" />
                            </div>
                            <div className="mt-14">
                                <p className="text-xs font-semibold uppercase tracking-[0.2em] text-fynary-muted">Email</p>
                                <p className="mt-2 font-display text-xl font-bold text-white sm:text-2xl">workfynary@gmail.com</p>
                            </div>
                        </a>
                    </Reveal>

                    <Reveal delay={0.12}>
                        <a
                            data-testid="contact-instagram-link"
                            href="https://www.instagram.com/fynary.in/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="group flex h-full flex-col justify-between rounded-[24px] border border-white/10 bg-fynary-surface p-6 transition-[border-color,background-color] duration-200 hover:border-fynary-lime/40 hover:bg-fynary-surface2 sm:p-8"
                        >
                            <div className="flex items-start justify-between">
                                <span className="flex h-12 w-12 items-center justify-center rounded-full bg-fynary-lime/10">
                                    <Instagram className="h-5 w-5 text-fynary-lime" />
                                </span>
                                <ArrowUpRight className="h-5 w-5 text-fynary-muted transition-[color,transform] duration-200 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-fynary-lime" />
                            </div>
                            <div className="mt-14">
                                <p className="text-xs font-semibold uppercase tracking-[0.2em] text-fynary-muted">Instagram</p>
                                <p className="mt-2 font-display text-xl font-bold text-white sm:text-2xl">@fynary.in</p>
                            </div>
                        </a>
                    </Reveal>
                </div>
            </div>
        </section>
    );
}
